// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default .cmb-summary--info .time{color:#f16e00}.cmb-summary--info .time{padding-top:7px;font-size:19px;font-weight:700}", ""]);
// Exports
module.exports = exports;
